import { cls } from "cls";

export const inputBase = cls(
  "form-input",
  "appearance-none bg-white bg-none rounded border-solid border box-border text-sm m-0 p-3 w-full transition-all duration-200",
  "focus:placeholder-transparent",
  "focus:outline focus:outline-2 focus:outline-[revert]",
);

export const inputBaseOptionalClasses = "border-gray-300";

export const inputError = "bg-red-100 border-red-300";

export const inputLabel =
  "block font-normal mb-1 relative text-left text-gray-600 transition-all";

export const inputMessageFont = "text-xs";

export const inputMessage = cls(
  inputMessageFont,
  "leading-4 left-0 bottom-2-1/2",
);

export const inputErrorMessage = cls(inputMessage, "text-red-500");

export const inputErrorMessageFont = cls(inputMessageFont, "text-red-500");

const selectInputIconBase = "pointer-events-none absolute top-0 right-0";

export const selectInputIcon = cls("mt-8", selectInputIconBase);

export const selectInputIconNoLabel = cls("mt-3", selectInputIconBase);

export const inputIcon = cls(
  "block",
  "mr-3",
  "absolute",
  "right-0",
  "bottom-0",
  "fill-current",
  "text-green-500",
  "hover:text-green-800",
  "transform",
  "-translate-y-full",
);

/**
 * Per design, this will make IE 11 position it properly
 * IE 11 does not support calc when used in this way
 */
export const inputIconInlineStyles = {
  transform: "translateY(calc(-25% - 1.5rem))",
  "-ms-transform": "translateY(-115%)",
};

export const inputButtonActionStyles =
  "bg-transparent border-none outline-none focus:outline-none text-gray-400";

export const inputCheckboxContainer =
  "cursor-pointer flex items-start mb-2 gap-2";

export const inputCheckbox = "flex-shrink-0 h-4 mt-1 w-4";

export const inputCheckboxText = "flex-auto ml-1";
